import React from 'react'
import { createUseStyles } from 'react-jss'
import obj2Arr from '../../utils/obj2Arr'

const useStyles = createUseStyles(theme => ({
  container: {
    padding: '45px 0',
    margin: '0 auto',
    width: '100%',
    maxWidth: '1220px',
    '@media (max-width: 1200px)': {
      boxSizing: 'border-box',
      padding: '45px 35px',
    },
    '@media (max-width: 700px)': {
      boxSizing: 'border-box',
      padding: '45px 15px',
    },
  },
  title: {
    fontSize: '32px',
    lineHeight: '42px',
    fontWeight: 700,
    fontFamily: 'TTRounds',
    textAlign: 'center',
    marginBottom: '82px',
    marginTop: 0,
    '@media (max-width: 700px)': {
      marginBottom: '50px',
    },
  },
  flexCont: {
    display: 'flex',
    justifyContent: 'space-evenly',
    textAlign: 'center',
    '@media (max-width: 750px)': {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  flexTitle: {
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: 700,
    fontFamily: 'TTRounds',
    textAlign: 'center',
    paddingTop: '33px',
    paddingBottom: '7px',
    '@media (max-width: 750px)': {
      paddingTop: '13px',
    },
  },
  flexDetails: {
    fontSize: '14px',
    lineHeight: '22px',
    fontWeight: 400,
    fontFamily: 'AvenirNextLTPro',
    textAlign: 'center',
  },
  flexDetailsSingleLine: {
    fontSize: '21px',
    lineHeight: '1.3',
    fontWeight: 300,
    fontFamily: 'AvenirNextLTPro',
    textAlign: 'center',
  },
  fxItem: {
    maxWidth: '220px',
    '@media (max-width: 750px)': {
      marginBottom: '30px',
    },
  },
}))

const Benefits = props => {
  const classes = useStyles()

  if (!props.title) return null

  const { title, backgroundcolor, singleline, benetifs, velocityDesign } = props

  const objArr = obj2Arr(benetifs)

  return (
    <div style={{ backgroundColor: backgroundcolor || '#fff' }}>
      <div className={classes.container}>
        <h2
          className={classes.title}
          style={velocityDesign == '1' ? { fontFamily: 'Montserrat', color: '#512698' } : {}}
        >
          {title}
        </h2>
        <div className={classes.flexCont}>
          {objArr &&
            objArr.map(section => (
              <div className={classes.fxItem} key={section.title}>
                <div>
                  <img src={section.img} alt={section.title} />
                </div>
                {singleline !== '0' && <div className={classes.flexTitle}>{section.title}</div>}
                <div
                  className={
                    singleline === '1' ? classes.flexDetailsSingleLine : classes.flexDetails
                  }
                >
                  {section.details}
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default Benefits
